import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import * as error from '../../shared/components/error-summary/error-handler.function';
import { WindowRefManager } from 'app/shared/services/window.service';

@Injectable()
export class FeatureService {

    constructor(private windowManager: WindowRefManager) { }

    public GetFeatureStatus(feature: string): boolean {
        return this.windowManager.nativeWindow.featureToggles[feature] === 'true';
    }

    public GetFeatureValue(feature: string): string {
        return this.windowManager.nativeWindow.featureToggles[feature];
    }
}


export class Feature {
    public static UseGoogleMaps = 'UseGoogleMaps';
    public static UsePayWithKMs = 'UsePayWithKMs';
    public static TranslationCacheTime = 'TranslationCacheTime';
    public static LastTCUpdate = 'LastTCUpdate';
    public static ShowTransactionHistory = 'ShowTransactionHistory';
    public static ShowSeatPreferenceSelection = 'ShowSeatPreferenceSelection';
    public static HideGoogleMaps = 'HideGoogleMaps';
}




// WEBPACK FOOTER //
// ./src/app/shared/services/feature.service.ts